export function calculateAge({ birthdate, today }: { birthdate: string | Date; today?: string | Date }): number {
    const birth = new Date(birthdate);
    let todayDate: Date;
    if (typeof today === 'string') {
        if (today.trim() !== '') {
            todayDate = new Date(today);
        } else {
            todayDate = new Date();
        }
    } else if (today instanceof Date) {
        todayDate = today;
    } else {
        todayDate = new Date();
    }
    let age = todayDate.getUTCFullYear() - birth.getUTCFullYear();
    const m = todayDate.getUTCMonth() - birth.getUTCMonth();
    if (m < 0 || (m === 0 && todayDate.getUTCDate() < birth.getUTCDate())) {
        age--;
    }
    return age;
}
